/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/ExpertSlider/theme';

export const ExpertSliderTheme = theme;
